import type { INotificationDto, INotificationResponse } from "./types";
import type { IPathBaseParam, IPathByIdParam } from "./path";

import type { IApiResponse, IPagination, IPaginationParams } from "@/api";
import { createGetAllApi } from "@api/util/createGetAllApi";
import { createPostApi } from "@api/util/createPostApi";
import { createGetApi } from "@api/util/createGetApi";
import { sent } from "@api/notifications/sent/api";
import { markAsRead } from "@api/notifications/markAsRead/api";

const getAllApis = createGetAllApi<
  IApiResponse<IPagination<INotificationResponse>>,
  IPathBaseParam,
  IPaginationParams
>("notifications");
const postApis = createPostApi<
  IApiResponse<INotificationResponse>,
  IPathBaseParam,
  INotificationDto
>("notifications");
const getApis = createGetApi<
  IApiResponse<INotificationResponse>,
  IPathByIdParam,
  object
>("notifications");

export const notifications = {
  ...getAllApis,
  ...getApis,
  ...postApis,
  sent,
  markAsRead,
};
